// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_W67","cls2":"ToolsMenu-cls2_YNt ToolsMenu-cls1_W67"};